import {useState, useEffect, useRef} from 'react';
import { Stack, Dialog, DialogTitle, DialogContent, TextField, DialogActions, DialogContentText, Box, FormControl, Button, Snackbar, Alert} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import './styles/Home.css';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';



export default function JoinRoomButton({socket}) {
    const [open, setOpen] = useState(false)
    const [error, setError] = useState('');
    // Tracks the "server didn't respond" timeout so the listener can cancel it on any reply.
    const timerRef = useRef(null);
    const handleClose = () => {setOpen(false)};
    const history = useHistory();

    useEffect(() => {
        const handler = (data) => {
            // Any reply (success or server-side error) means the server is alive — cancel timeout.
            if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
            if (data.status === 'success') {
                // redirect to /game/{roomID}
                history.push({pathname: `/game/${data.roomID}`, state: {...data, player: 'p2'}});
            } else {
                // show the server's error in a snackbar; keep the dialog open to retry
                setError(data.error)
            }
        };
        socket.on('room_joined', handler);
        return () => {
            socket.off('room_joined', handler);
            if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
        };
    }, [socket, history])

    return (<>
        <Button className='btn' color='inherit' variant="outlined" onClick={() => setOpen(true)} endIcon={<PlayCircleOutlineRoundedIcon/>}>
            Join Room
        </Button>
          <Dialog
            fullWidth
            maxWidth='sm'
            open={open}
            onClose={handleClose}
          >
            <DialogTitle> Join a Room </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Ask your friend for the room id and Choose your username!
              </DialogContentText>
              <Box sx={{ mt: 3, mb:-2 }}>

                <JoinRoomForm socket={socket} setError={setError} timerRef={timerRef}/>

              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>

        <Snackbar
            open={!!error}
            autoHideDuration={4000}
            onClose={() => setError('')}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert severity="error" variant="filled" onClose={() => setError('')} sx={{ width: '100%' }}>
                {error}
            </Alert>
        </Snackbar>

        </>)
}




export function JoinRoomForm({socket, setError, timerRef}) {

    const [id, setID] = useState('');
    const [username, setUsername] = useState('');
    const {handleSubmit} = useForm();
    

    function handleChangeUsername(event) {
        setUsername(event.target.value);
    }

    function handleChangeID(event) {
        setID(event.target.value);
    }

    const OnSubmit = () => {
        const data = {
        roomID: id,
        username: username.length > 0 ? username : "Player 2",
    };

        // Don't silently fail when the socket is disconnected (e.g. backend down).
        if (!socket.connected) {
            setError("Can't reach the server. Please try again in a moment.");
            return;
        }

        socket.emit("join_room", data);

        // If the server never replies (transient hang), surface that too.
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setError("Server didn't respond. Please try again.");
            timerRef.current = null;
        }, 5000);
    }

    return (
        <div align='left'>
            <form onSubmit={handleSubmit(OnSubmit)}>
            <Stack>
            <FormControl size="medium">
                    <TextField
                        sx={{ m: 1 }}
                        fullWidth
                        label="Your Name"
                        placeholder="Player 2"
                        value={username}
                        onChange={handleChangeUsername}
                        helperText={username.length > 0 ? `Goodluck ${username}!` : ''}
                    />
            </FormControl>

            <FormControl size="medium">
                    <TextField
                        sx={{ m: 1 }}
                        fullWidth
                        label="Room ID"
                        error={Boolean(id.length !== 6)}
                        helperText={id.length === 6 ? '' :'Please enter a valid room id.'}
                        onChange={handleChangeID}
                    />
            </FormControl>

            <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            >
                Join Room
            </Button>
            </Stack>
            </form>
    
        </div>

    )

}
